export const QipKeys = {
  all: ['qip'] as const,
  questions: () => [...QipKeys.all, 'questions'] as const,
  question: (id: string) => [...QipKeys.questions(), id] as const,
  choices: () => [...QipKeys.all, 'choices'] as const,
  choice: (id: string) => [...QipKeys.choices(), id] as const,
  questionGroups: () => [...QipKeys.all, 'questionGroups'] as const,
  questionGroup: (id: string) => [...QipKeys.questionGroups(), id] as const,
  conditions: () => [...QipKeys.all, 'conditions'] as const,
};
